var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFallback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15_64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.04351 0.0647478L6.07461 0.545963L6.57357 0.513719C6.71432 0.504623 6.85636 0.5 6.99955 0.5H6.99963H7.00037H7.00045C7.14364 0.5 7.28568 0.504623 7.42643 0.513719L7.92539 0.545963L7.95649 0.0647477C9.1748 0.231144 10.2933 0.711037 11.2281 1.42047L10.91 1.78289L11.2858 2.11271C11.4991 2.29993 11.7001 2.50089 11.8873 2.71421L12.2171 3.09L12.5795 2.77192C13.289 3.70668 13.7689 4.82519 13.9353 6.04351L13.454 6.07461L13.4863 6.57357C13.4954 6.71432 13.5 6.85636 13.5 6.99955V6.99963V7.00037V7.00045C13.5 7.14364 13.4954 7.28568 13.4863 7.42643L13.454 7.92539L13.9353 7.95649C13.7689 9.1748 13.289 10.2933 12.5795 11.2281L12.2171 10.91L11.8873 11.2858C11.7001 11.4991 11.4991 11.7001 11.2858 11.8873L10.91 12.2171L11.2281 12.5795C10.2933 13.289 9.17481 13.7689 7.95649 13.9353L7.9254 13.454L7.42644 13.4863C7.28568 13.4954 7.14364 13.5 7.00045 13.5H7.00037H6.99963H6.99955C6.85636 13.5 6.71432 13.4954 6.57357 13.4863L6.07461 13.454L6.04351 13.9353C4.8252 13.7689 3.70668 13.289 2.77192 12.5795L3.09 12.2171L2.71421 11.8873C2.5009 11.7001 2.29993 11.4991 2.11271 11.2858L1.78289 10.91L1.42047 11.2281C0.711038 10.2933 0.231144 9.17481 0.0647478 7.95649L0.545963 7.9254L0.513719 7.42644C0.504623 7.28568 0.5 7.14364 0.5 7.00045V7.00037V6.99963V6.99955C0.5 6.85636 0.504623 6.71432 0.513719 6.57357L0.545963 6.07461L0.0647477 6.04351C0.231144 4.8252 0.711037 3.70668 1.42047 2.77192L1.78289 3.09L2.11271 2.71421C2.29993 2.5009 2.50089 2.29993 2.71421 2.11271L3.09 1.78289L2.77192 1.42047C3.70668 0.711038 4.82519 0.231144 6.04351 0.0647478Z",
    stroke: "black",
    fill: "lightgray",
    fillOpacity: 0.2,
    strokeOpacity: 0.1,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_64"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFallback);
export default __webpack_public_path__ + "static/media/FALLBACK.0ef99a13509c050d7ece045f9ebff367.svg";
export { ForwardRef as ReactComponent };